import { FC } from 'react';

export type TProps = {
  src: string;
};

const LightboxPdf: FC<TProps> = (props) => {
  const { src } = props;

  return (
    <embed
      // oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Viewport-relative size
      className="w-full h-[calc((100svh-(var(--spacing-4)*2)-7rem))]"
      src={src}
      type="application/pdf"
      title="Embedded PDF Viewer"
    />
  );
};

export default LightboxPdf;
